/**
 * @name Remove Empty Paragraphs
 * @description This script finds all elements matching a specific selector
 * and removes any empty paragraphs (<p>) from within them.
 * "Empty" is defined as a paragraph that contains only whitespace, <br> tags, or   entities.
 */
function removeEmptyParagraphs() {
  // 1. Define the selector for the container elements.
  const containerSelector = '.product-block--tab .collapsible-content__inner';

  // 2. Select all container elements on the page.
  const containers = document.querySelectorAll(containerSelector);

  // 3. If no containers are found, stop the script.
  if (containers.length === 0) {
    console.log('No matching containers found to clean.');
    return;
  }

  console.log(`Found ${containers.length} container(s) to clean.`);

  // 4. Loop through each container found.
  containers.forEach((container, index) => {
    // 5. Find all paragraph tags (<p>) inside the current container.
    const paragraphs = container.querySelectorAll('p');
    let removedCount = 0;

    // 6. Loop through each paragraph to check if it's empty.
    paragraphs.forEach(p => {
      // The .textContent property gets the text content of an element, ignoring HTML tags like <br>.
      // The .trim() method removes whitespace from both ends of a string.
      // If the result is an empty string, the paragraph is visually empty.
      if (p.textContent.trim() === '' && p.innerHTML.includes('<br>')) {
        // Specifically targets <p><br></p> and similar variations
        p.remove();
        removedCount++;
      } else if (p.innerHTML.trim() === '') {
        // Specifically targets <p></p> and <p>    </p>
        p.remove();
        removedCount++;
      }
    });

    if (removedCount > 0) {
      console.log(`Removed ${removedCount} empty paragraph(s) from container #${index + 1}.`);
    }
  });
}

// Run the function after the page content has fully loaded.
// This is the safest way to ensure all elements are available to the script.
document.addEventListener('DOMContentLoaded', removeEmptyParagraphs);

/**
 * @name Initialize Cart Date Pickers
 * @description Initializes Flatpickr date pickers for cart delivery and trade show date fields
 */
function initializeCartDatePickers() {
  // Check if we're on the cart page and if extra fields are enabled
  const cartForm = document.getElementById('CartPageForm');
  if (!cartForm) return;

  const deliveryDateField = document.getElementById('CartDeliveryDate');
  const tradeShowDateField = document.getElementById('CartTradeShowDate');

  // Only proceed if both date fields exist
  if (!deliveryDateField || !tradeShowDateField) return;

  // Common Flatpickr options
  const commonOptions = {
    dateFormat: 'Y-m-d',
    allowInput: false,
    clickOpens: true,
    disableMobile: false,
    locale: {
      firstDayOfWeek: 1, // Monday
      weekdays: {
        shorthand: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        longhand: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
      },
      months: {
        shorthand: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        longhand: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
      }
    },
    onChange: function(selectedDates, dateStr, instance) {
      // Fields are no longer required, no validation needed
      // Date changes don't affect checkout button state
    }
  };

  // Initialize delivery date picker
  if (deliveryDateField) {
    const deliveryPicker = flatpickr(deliveryDateField, {
      ...commonOptions,
      minDate: 'today',
      placeholder: 'Select delivery date'
    });
  }

  // Initialize trade show date picker
  if (tradeShowDateField) {
    const tradeShowPicker = flatpickr(tradeShowDateField, {
      ...commonOptions,
      minDate: 'today',
      placeholder: 'Select trade show date'
    });
  }

  console.log('Cart date pickers initialized successfully');
}

// Initialize date pickers when DOM is loaded
document.addEventListener('DOMContentLoaded', initializeCartDatePickers);

// Also initialize when cart is updated (for dynamic cart updates)
document.addEventListener('cart:updated', initializeCartDatePickers);